import * as React from "react";
import axios from "axios";

export const renderPrice = (value: number) => {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value);
};

export const renderPercent = (value: number) => {
  return new Intl.NumberFormat('fr-FR', { style: 'percent', minimumFractionDigits: 0 }).format(value / 100);
};

export const renderPriceDecimals = (value: number, lang: string, widthAsterisk: boolean = false) => {
  const priceTotal = value.toFixed(2).replace('.', ',');
  const entier = priceTotal.split(",")[0];
  const decimal = priceTotal.split(",")[1];

  return (
    <span className={'d-flex lineheight-1 justify-content-center'}>
      {entier}
      <span className={'d-flex flex-column align-items-start'}>
        <span className={'supSize'}>€
          {decimal != '00' &&
          <span className={''}>{decimal}</span>
          }
        </span>
        <span className={'htSize opac50 openSansRegular pl-1'}>
          {lang && lang == 'fr' ? (
            <>HT</>
            ) : (
            <>EXCL. TAX/Unit</>
          )}
          {widthAsterisk &&
          <span className={''}>*</span>
          }
        </span>
      </span>
    </span>
  );
};

export function loadHtml(lng: string, namePage: string) {
  return axios.get(`${window.location.origin}/html/${lng}/${namePage}.html`)
    .then((res) => {
      return res.data;
    }).catch((err) => {
    //console.error(err);
  });
}

export function removeFileInLocaleStorage(creationId: any) {
  if (localStorage && localStorage['filesStorage']) {
    const visuelsPresents = localStorage['filesStorage'] ? JSON.parse(localStorage['filesStorage']) : {};
    for (const [key, ] of Object.entries(visuelsPresents)) {
      if(key === creationId) {
        delete visuelsPresents[key];
      }
    }
    if(Object.keys(visuelsPresents).length > 0) {
      localStorage.setItem('filesStorage', JSON.stringify(visuelsPresents));
    } else {
      localStorage.removeItem('filesStorage');
    }
  }
}

export function getFileInLocaleStorage() {
  if (localStorage && localStorage['filesStorage']) {
    const visuelsPresents = localStorage['filesStorage'] ? JSON.parse(localStorage['filesStorage']) : {};
    const visuelPresentsRdy = visuelsPresents;
    for (const [key,] of Object.entries(visuelPresentsRdy)) {
      if (typeof visuelPresentsRdy[key].fichierSrc === 'undefined' || (visuelPresentsRdy[key].fichierSrc && visuelPresentsRdy[key].fichierSrc.startsWith('/images/source-visuels/')) || new Date() > new Date(visuelPresentsRdy[key].expirationDate)) {
        delete visuelPresentsRdy[key];
        }
    }
    if(visuelPresentsRdy!== JSON.parse(localStorage['filesStorage'])) {
      localStorage.setItem('filesStorage', JSON.stringify(visuelsPresents));
    }
    return visuelsPresents;
  }
}

